import { stringify } from 'qs';
export function stringifyQuery<Params extends object>(params: Params): string {
  return stringify(params as unknown as Record<string, unknown>);
}
